import { render, staticRenderFns } from "./ConsultingPageRus.vue?vue&type=template&id=46c96460&scoped=true&"
var script = {}
import style0 from "./ConsultingPageRus.vue?vue&type=style&index=0&id=46c96460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c96460",
  null
  
)

export default component.exports